<template>
  <el-dialog
    :visible.sync="showDialog"
    custom-class="card"
    @open="doOpen"
    @closed="doClosed"
    append-to-body
  >
    <template v-if="showContent">
      <div class="icon-lock">
        <img src="./../../../assets/images/img-domain.png" alt>
      </div>
      <div class="dialog-title">
        <h5>绑定域账号</h5>
        <p>
          绑定成功后您的邮箱将变更为万科邮箱
          <br>同时密码也将改变
        </p>
      </div>
      <el-form :model="formData" class="dialog-form">
        <div>
          <el-form-item>
            <el-input v-model="formData.domain" placeholder="域账号" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item class="pr">
            <el-input
              v-model="formData.pass"
              placeholder="密码"
              :type="showPass ? 'text' : 'password'"
              maxlength="20"
            ></el-input>
            <div class="btn-show" @click="showPass=!showPass">
              <i class="el-icon-view"></i>
            </div>
          </el-form-item>
        </div>
        <div class="gap"></div>
        <transition name="magic">
          <p v-if="showTips"></p>
        </transition>
      </el-form>

      <div class="btn-box">
        <button class="btn btn-cancel" @click="showDialog = false;">取消</button>
        <button class="btn btn-save" @click="handleUpdate">绑定</button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import aes from "@/uitls/aes";

export default {
  components: {},
  computed: {
    ...mapState(["userInfo", "unlockData"]),
    // dialog show/hide
    showDialog: {
      // getter
      get: function() {
        return this.visible;
      },
      // setter
      set: function(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formData: {
        domain: "",
        pass: ""
      },
      showTips: false,
      // test flight - showContent: false
      showContent: true,
      showPass: false
    };
  },
  methods: {
    doClosed() {
      this.showContent = false;
      this.showTips = false;
    },
    doOpen() {
      this.showContent = true;
      this.formData.domain = "";
      this.formData.pass = "";
    },
    // update(link) domain by {unlock code, unlock phone}, {domain account, password}
    handleUpdate() {
      this.$http
        .post("/user-server/setting/change/account", {
          unlockPhone: this.userInfo.phoneNo,
          unlockCode: this.unlockData.code,
          userAccount: this.formData.domain,
          password: this.formData.pass
          // aes.Encrypt(this.formData.pass),
        })
        .then(res => {
          if (res.data.code == 200) {
            this.doUpdate();
          }
          this.$eventHub.$emit('sendUpdate', res)
        })
        .catch(err => {
          console.log("ERROR", err);
        });
    },
    doUpdate() {
      this.$emit("update");
      this.showDialog = false;
    }
  },
  watch: {},
  mounted: function() {}
};
</script>

<style lang="scss" scoped>
@import "../styles/card.scss";
.dialog-form {
  .btn-show {
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 20px;
    right: 0px;
    top: 10px;
  }
}
</style>
<style lang="scss">
/* overwrite el-dialog */
.card {
  &.el-dialog {
    width: 440px;
    border-radius: 6px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .el-form-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userInfo/components/cardD.vue